import { RoomItem, StyledFlex, RoomItemV2 } from '@tryhackme/thm-ui-components';
import { useFeatureIsOn } from 'src/common/growthbook';
import { PovTagFilterOptions } from 'src/features/hacktivities/challenges/challenges.types';
import { Room } from '../skill-details/skill-details.types';
import { StyledEmptyMessage, StyledRoomItem, StyledRoomLoading } from './rooms-list.style';
export const RoomsList = ({
  rooms,
  isFetching
}: {
  rooms?: Room[];
  isFetching: boolean;
}) => {
  const isNewRoomsEnabled = useFeatureIsOn('skills-matrix-new-rooms');
  return isFetching ? <StyledFlex flexDirection="column" gap="1rem" data-testid="loading">
      <br />
      <StyledRoomLoading width="100%" height="48px" />
      <StyledRoomLoading width="100%" height="48px" />
      <StyledRoomLoading width="100%" height="48px" />
    </StyledFlex> : <ul>
      {rooms?.length === 0 && <StyledEmptyMessage>No rooms</StyledEmptyMessage>}
      {rooms?.map(room => {
      const povTag = (room.tagDocs?.find(tagDoc => tagDoc.category === 'PoV')?.tag.toLowerCase() as PovTagFilterOptions);
      const technologies = room.tagDocs?.filter(tagDoc => tagDoc.category === 'Technology').map(tagDoc => tagDoc.tag);
      return <StyledRoomItem key={room.code}>
            {isNewRoomsEnabled ? <RoomItemV2 image={room.imageURL ?? ''} title={room.title} progressValue={room.progress} roomCode={room.code ?? ''} description={room.description} isDarkVersion pageReferrer="matrix" difficulty={room.difficulty} povTag={povTag} techsTags={technologies} duration={room.timeToComplete ? `${room.timeToComplete} mins` : ''} /> : <RoomItem image={room.imageURL ?? ''} title={room.title} progressValue={room.progress} roomCode={room.code ?? ''} isDarkVersion pageReferrer="matrix" />}
          </StyledRoomItem>;
    })}
    </ul>;
};